// @ts-nocheck
import _ from 'lodash';
import pageSettingsPanelConstants from './constants';

function getProtectionType(editorAPI, pageData) {
  const pageSecurityData = pageData?.pageSecurity;
  if (pageSecurityData.requireLogin) {
    return pageSettingsPanelConstants.PERMISSION_STATES.MEMBERS;
  }

  if (isPageProtectedWithPassword(editorAPI, pageData)) {
    return pageSettingsPanelConstants.PERMISSION_STATES.PASSWORD;
  }

  return pageSettingsPanelConstants.PERMISSION_STATES.NONE;
}

function doesPageHavePasswordOnServer(editorAPI, pageId) {
  return editorAPI.pages.permissions.hasPassword(pageId);
}

function isPageProtectedWithPassword(editorAPI, pageData) {
  return (
    !_.isEmpty(pageData?.pageSecurity?.passwordDigest) ||
    doesPageHavePasswordOnServer(editorAPI, pageData.id)
  );
}

export { getProtectionType, isPageProtectedWithPassword };
